<template>
  <div class="content" :class="{'vh-100': !modalView}">
    <div class="card">
      <profile-picture :user-full-name="firstName + ' ' + lastName" big-name/>
      <div class="row">
        <div class="col">
          <div class="p-2">
            <div class="label">{{ $t('profileInfo.username') }}: </div>{{ userName }}
          </div>
          <div class="p-2">
            <div class="label">{{ $t('profileInfo.loggedAs') }}: </div>{{ rol }}
          </div>
          <div class="p-2">
            <div class="label">{{ $t('profileInfo.email') }}: </div>{{ email }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfilePicture from '@/components/ProfilePicture'

export default {
  'name': 'ProfileDetails',
  components: { ProfilePicture },
  props: {
    modalView: {
      type: Boolean,
      default: false
    }
  },
  'computed': {
    userName() {
      return this.$store.state.loggedUser.username
    },
    firstName() {
      return this.$store.state.loggedUser.firstname
    },
    lastName() {
      return this.$store.state.loggedUser.lastname
    },
    email() {
      return this.$store.state.loggedUser.email
    },
    rol() {
      if (this.$store.state.loggedUser.roles.length > 0) {
        return this.$store.state.loggedUser?.roles[0]?.description ?? ''
      }
      return ''
    }
  }
}
</script>
<style scoped>
.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.card {
  width: 90%;
  background-color: #f5f5f5;
  border-radius: 4px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.19);
  padding: 40px 10px;
  max-width: 700px;
}

.label {
  font-weight: bold;
  font-size: 18px;
  display: inline;
}
</style>